/**
 * PDP gallery lightbox — video playback
 *
 * The React gallery (assets/tvg-snippet-core-react-product-gallery.js, auto-generated)
 * passes `autoplay: index === mediaIndex` to each lightbox slide, where `mediaIndex`
 * is the media the lightbox was OPENED at. The Video component only acts on that flag
 * from its one-shot `loadeddata` listener, so paging to a video with the lightbox
 * arrows never starts it — the flag was resolved for a different slide. The video
 * sits on its poster frame even though the same clip auto-plays in the gallery grid.
 *
 * This script drives playback off the slide that is actually on screen, without
 * touching the auto-generated bundle:
 *   - lightbox open / slide change -> play the active slide's video, pause the rest
 *   - lightbox close               -> pause every lightbox video
 *
 * Only videos inside the lightbox are touched; the grid tiles keep their own
 * behaviour. Re-attaches itself after the shade selector swaps the product-main
 * section (assets/shade-selector.js).
 */

(function () {
  'use strict';

  if (window.__pdpLightboxVideoInit) return;
  window.__pdpLightboxVideoInit = true;

  // TVG class names carry a build hash (…_0Q3Jlq_galleryLightbox), so match on the
  // stable suffix. The overlay/close/content children use the `__element` form.
  var LIGHTBOX_SELECTOR = '[class*="_galleryLightbox"]';

  var lightbox = null;
  var lightboxObserver = null;
  var frame = null;

  function findLightbox() {
    var candidates = document.querySelectorAll(LIGHTBOX_SELECTOR);
    for (var i = 0; i < candidates.length; i++) {
      if (!/_galleryLightbox__/.test(candidates[i].className || '')) return candidates[i];
    }
    return null;
  }

  function isOpen(el) {
    return window.getComputedStyle(el).display !== 'none';
  }

  // Unmuted autoplay is blocked without user activation; fall back to muted so the
  // shopper always sees the clip move, the same way the grid tile behaves.
  function play(video) {
    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        video.muted = true;
        var retry = video.play();
        if (retry && typeof retry.catch === 'function') retry.catch(function () {});
      });
    }
  }

  function sync() {
    if (!lightbox || !lightbox.isConnected) return;

    var activeSlide = isOpen(lightbox) ? lightbox.querySelector('.swiper-slide-active') : null;
    var active = activeSlide ? activeSlide.querySelector('video') : null;
    var videos = lightbox.querySelectorAll('video');

    for (var i = 0; i < videos.length; i++) {
      if (videos[i] !== active && !videos[i].paused) videos[i].pause();
    }

    if (active) play(active);
  }

  function scheduleSync() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      sync();
    });
  }

  function attach() {
    var found = findLightbox();
    if (!found || found === lightbox) return;

    if (lightboxObserver) lightboxObserver.disconnect();
    lightbox = found;

    // `style` flips display between none/flex on open and close; `class` catches
    // Swiper moving `swiper-slide-active` as the shopper pages through the lightbox.
    lightboxObserver = new MutationObserver(scheduleSync);
    lightboxObserver.observe(lightbox, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      subtree: true
    });

    scheduleSync();
  }

  // The gallery mounts (and remounts, on every shade swap) well after DOMContentLoaded.
  new MutationObserver(function () {
    if (!lightbox || !lightbox.isConnected) attach();
  }).observe(document.documentElement, { childList: true, subtree: true });

  attach();
})();
